/* eslint-disable react-hooks/exhaustive-deps */
import dynamic from "next/dynamic";

import React, { Fragment, useEffect, useState } from "react";
const Icon = dynamic(() => import("@/components/ui/Icon"), { ssr: false });
import useWidth from "@/hooks/useWidth";
import Logo from "./Tools/Logo";
import Profile from "./Tools/Profile";
import useMobileMenu from "@/hooks/useMobileMenu";
import ReportModal from "@/components/partials/header/Tools/report-modal";
import SearchNodePurchasedModal from "@/components/partials/header/Tools/node-search";
import { useSearchParams } from "next/navigation";
import EmailModal from "./Tools/email-modal";
import ShortUniqueId from "short-unique-id";
import LoginButton from "./Tools/login-button";
const LoadingModal = dynamic(() =>
  import("@/components/partials/header/Tools/loading-modal")
);
import MessageModal from "@/components/ui/Message-Modal";
import MXSAmount from "./Tools/mxs-amount";
import Image from "next/image";
const Button = dynamic(() => import("@/components/ui/Button"));
import Notification from "./Tools/Notification";
import TokenBalance from "./Tools/token-balance";
import Launcher from "./Tools/launcher-button";
import { isMobile, deviceType } from "react-device-detect";
import { watchSentReports, reloadPage } from "@/utils/helpers/helperFunctions";
import { useAuth } from "@/contexts/authContext";
import SearchTokenAllocationModal from "@/components/partials/header/Tools/token-allocation-search";
import { incrementReferralClicks } from "@/supabase/functions";
import { supabase } from "@/supabase/client";

const Header = ({ className = "custom-class" }) => {
  const {
    isAuthenticated,
    isFetchingUser,
    isWalletConnecting,
    user,
    ipAddress,
    isSignedUp,
    isLoggedOut,
    openLoginModal,
  } = useAuth();

  const { width, breakpoints } = useWidth();
  const [showErrorModal, setShowErrorModal] = React.useState(false);
  const [activeError, setActiveError] = React.useState(null);
  const [activeErrorTitle, setActiveErrorTitle] = React.useState(null);
  const [showSuccessModalForReport, setShowSuccessModalForReport] =
    useState(false);
  const [mobileMenu, setMobileMenu] = useMobileMenu();
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isLoadingModalOpen, setIsLoadingModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [showErrorModalForReportTry, setShowErrorModalForReportTry] =
    useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false); // State for Search Node modal
  const [launcherActivity, setLauncherActivity] = useState(null);
  const [mobileView, setMobileView] = useState(false);
  const [isTokenAllocationModalOpen, setIsTokenAllocationModalOpen] =
    useState(false);

  const uid = new ShortUniqueId({ length: 4, dictionary: "number" });
  const uidOnSearchParams = useSearchParams().get("uid");
  const referrerOnSearchParams = useSearchParams().get("referrer");

  useEffect(() => {
    if ((isSignedUp && user && !isFetchingUser) || isLoggedOut) {
      reloadPage();
    }
  }, [isSignedUp, user, isLoggedOut, isFetchingUser]);

  useEffect(() => {
    if (isWalletConnecting || isFetchingUser) {
      setIsLoadingModalOpen(true);
    } else {
      setIsLoadingModalOpen(false);

      if (isAuthenticated && !isFetchingUser && user) {
        if (user?.email === null || user?.email === "") {
          // setIsEmailModalOpen(true);
        } else {
          setIsEmailModalOpen(false);
        }
      }

      if (!isFetchingUser && !isWalletConnecting && !isAuthenticated) {
        if (uidOnSearchParams) {
          openLoginModal();
        }
      }
    }
  }, [isWalletConnecting, isFetchingUser, user, uidOnSearchParams]);

  // useEffect(() => {
  //   if (uidOnSearchParams) {
  //     const handleUserReferralClicks = async () => {
  //       const user = await getUserWithUID(uidOnSearchParams);
  //       if (user) {
  //         if (!user.user_referral_clicks) {
  //           await updateUserFieldWithUID(
  //             uidOnSearchParams,
  //             "user_referral_clicks",
  //             1
  //           );
  //         } else {
  //           await updateUserFieldWithUID(
  //             uidOnSearchParams,
  //             "user_referral_clicks",
  //             user.user_referral_clicks + 1
  //           );
  //         }
  //       }
  //     };

  //     handleUserReferralClicks();
  //   }
  // }, [uidOnSearchParams]);

  useEffect(() => {
    if (referrerOnSearchParams && user?.uid) {
      const handleReferrerReferralClicks = async () => {
        // Check if this is an NFT referral by checking the URL path
        const isNFTReferral = window.location.pathname.includes("/nft");

        await incrementReferralClicks(
          referrerOnSearchParams,
          isNFTReferral ? "nft" : "user",
          user.uid
        );
      };

      handleReferrerReferralClicks();
    }
  }, [referrerOnSearchParams, user?.uid]);

  useEffect(() => {
    const getLauncherActivity = async () => {
      try {
        const { data, error } = await supabase
          .from("mxs_play_launcher_user")
          .select("*")
          .eq("uid", user.user_id || user.uid)
          .maybeSingle();

        if (error) {
          console.error("Error fetching launcher activity:", error);
          setLauncherActivity(null);
        } else if (data) {
          setLauncherActivity(data);
        } else {
          setLauncherActivity(null);
        }
      } catch (error) {
        console.error("Error fetching launcher activity:", error);
        setLauncherActivity(null);
      }
    };

    if (user && isAuthenticated && !isFetchingUser) {
      getLauncherActivity();
    }
  }, [user, isAuthenticated, isFetchingUser]);

  useEffect(() => {
    if (isMobile || deviceType === "tablet") {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, []);

  const handleOpenMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <div className="w-full pl-0 lg:pl-36">
      <header className={className + " " + " sticky top-0 z-[999] "}>
        <div
          className={
            "app-header xl:container px-[15px] dark:bg-metaxseed-black shadow-base dark:shadow-base3 bg-white dark:border-b dark:border-zinc-900 dark:border-opacity-60 py-3"
          }
        >
          <div className="flex justify-between items-center h-full relative">
            {/* Mobile Layout */}
            {width <= breakpoints.md ? (
              <>
                {/* Left side - Hamburger Menu */}
                <div className="flex items-center">
                  <div
                    className="cursor-pointer text-zinc-900 dark:text-white text-3xl"
                    onClick={handleOpenMobileMenu}
                  >
                    <Icon icon="heroicons-outline:menu-alt-3" />
                  </div>
                  {/* <Logo /> */}
                </div>

                {/* Right side - Essential tools and Profile */}
                <div className="flex items-center">
                  {isAuthenticated && !isFetchingUser && (
                    <>
                      {/* Notification with better positioning */}
                      <div className="relative z-[9999]">
                        <Notification />
                      </div>

                      {/* Balance displays with tighter spacing */}
                      <div className="flex items-center">
                        {/* Token Balance */}
                        <div className="scale-75 md:scale-90 lg:scale-100 origin-center">
                          <TokenBalance />
                        </div>

                        {/* MXS Amount */}
                        <div className="scale-75 md:scale-90 lg:scale-100 origin-center">
                          <MXSAmount />
                        </div>
                      </div>

                      <Profile
                        searchModalClicked={() => {
                          setIsSearchModalOpen(true);
                        }}
                        tokenAllocationSearchClicked={() => {
                          setIsTokenAllocationModalOpen(true);
                        }}
                      />
                    </>
                  )}
                  {!isAuthenticated && !isFetchingUser && <LoginButton />}
                </div>
              </>
            ) : (
              <>
                {/* Desktop Layout */}
                <div className="flex items-center md:space-x-4 space-x-2 rtl:space-x-reverse">
                  {/* open mobile menu handler for tablet */}
                  {width < breakpoints.xl && width >= breakpoints.md && (
                    <div
                      className="cursor-pointer text-zinc-900 dark:text-white text-3xl"
                      onClick={handleOpenMobileMenu}
                    >
                      <Icon icon="heroicons-outline:menu-alt-3" />
                    </div>
                  )}
                </div>

                {/* Desktop Nav Tools */}
                <div className="nav-tools flex items-center lg:space-x-6 space-x-3 rtl:space-x-reverse">
                  {isAuthenticated && !isFetchingUser && (
                    <Fragment>
                      <Notification />
                    </Fragment>
                  )}

                  {!mobileView &&
                    (isAuthenticated && !isFetchingUser && user ? (
                      <Launcher launcher={launcherActivity} />
                    ) : (
                      <></>
                    ))}

                  <Fragment>
                    {isAuthenticated && !isFetchingUser && <TokenBalance />}
                    {isAuthenticated && !isFetchingUser && <MXSAmount />}

                    {!isFetchingUser && <LoginButton />}
                    {isAuthenticated && !isFetchingUser && (
                      <Profile
                        searchModalClicked={() => {
                          setIsSearchModalOpen(true);
                        }}
                        tokenAllocationSearchClicked={() => {
                          setIsTokenAllocationModalOpen(true);
                        }}
                      />
                    )}
                  </Fragment>

                  {process.env.NEXT_PUBLIC_CONNECTED_DB === "development" && (
                    <Button
                      disabled={true}
                      icon="material-symbols:database-outline"
                      text={"Test DB Connected"}
                      iconClass="text-2xl text-white w-6 h-6 text-center flex justify-center items-center"
                      className="border-red-600 border rounded-full p-4 min-w-12 !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none !shadow-none bg-metaxseed-content-gray hover:bg-[#3c3c3c] disabled:bg-metaxseed-content-gray"
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        {isEmailModalOpen && (
          <EmailModal
            givenUser={user}
            isOpen={isEmailModalOpen}
            onClose={(event) => {
              if (event) {
                setIsEmailModalOpen(false);
              }
            }}
            uid={user.user_id || user.uid}
          />
        )}
        {isLoadingModalOpen && (
          <LoadingModal
            isOpen={isLoadingModalOpen}
            onClose={(e) => {
              if (e) {
                setIsLoadingModalOpen(false);
              }
            }}
          />
        )}
        {showErrorModal && (
          <MessageModal
            title={activeErrorTitle || "Error"}
            status={false}
            centered
            activeModal={showErrorModal}
            className="max-w-xl errorModalShadow"
            onClose={(event) => {
              if (event) {
                setShowErrorModal(false);
                setTimeout(() => {
                  setActiveError(null);
                }, 300);
              }
            }}
          >
            <div className="font-medium py-2">
              {activeError || "An error occurred. Please try again later."}
            </div>
          </MessageModal>
        )}

        {showSuccessModalForReport && (
          <MessageModal
            title={`Thank you!`}
            fireworks={false}
            status={true}
            centered
            activeModal={showSuccessModalForReport}
            onClose={() => {
              setShowSuccessModalForReport(false);
            }}
          >
            <div className="flex items-center">
              <Image
                src={
                  "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fgeneral_media%2F0c72afb44d6ff7f0e7280d050c078407_w200.webp?alt=media&token=6edb828c-a3a5-482d-8ca1-4bdcb1f734ec"
                }
                width={200}
                height={200}
                alt=""
                className="mb-4 max-h-[100px] xl:max-h-[200px] !max-w-fit mx-auto"
              />
            </div>
            <div className="gothamBook text-metaxseed-text-gray py-2 text-center">
              Thanks for participating and helping us maintain the quality of
              our service. Your report has been successfully submitted.
            </div>
          </MessageModal>
        )}

        {showErrorModalForReportTry && (
          <MessageModal
            title={`Limit Exceeded!`}
            fireworks={false}
            status={false}
            centered
            activeModal={showErrorModalForReportTry}
            onClose={(e) => {
              if (e) {
                setShowErrorModalForReportTry(false);
              }
            }}
          >
            <div className="flex items-center">
              <Image
                src={
                  "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fgeneral_media%2F2iFb.gif?alt=media&token=e94a95a8-710f-4f13-84a3-eeb821318379"
                }
                width={200}
                height={200}
                alt=""
                className="mb-4 max-h-[100px] xl:max-h-[200px] !max-w-fit mx-auto"
              />
            </div>
            <div className="gothamBook text-metaxseed-text-gray py-2 text-center">
              We&apos;re sorry, but you've reached the maximum limit for report
              submissions within one hour. Please try again later.
            </div>
          </MessageModal>
        )}

        {isReportModalOpen && (
          <ReportModal
            user={user}
            isOpen={isReportModalOpen}
            onClose={(e) => {
              if (typeof e === "object") {
                setIsReportModalOpen(false);
              } else if (e) {
                setIsReportModalOpen(false);
                setShowSuccessModalForReport(true);
                watchSentReports(user);
              }
            }}
          />
        )}

        {isSearchModalOpen && (
          <SearchNodePurchasedModal
            isOpen={isSearchModalOpen}
            onClose={(e) => {
              if (e) {
                setIsSearchModalOpen(false);
              }
            }}
          />
        )}

        {isTokenAllocationModalOpen && (
          <SearchTokenAllocationModal
            isOpen={isTokenAllocationModalOpen}
            onClose={(e) => {
              if (e) {
                setIsTokenAllocationModalOpen(false);
              }
            }}
          />
        )}
      </header>
    </div>
  );
};

export default Header;
